import { useQuery } from "@tanstack/react-query";
import { rpc } from "#rpc";
import type { BlokData } from "~/srpc/routes/story.router";

export const useCorrectionSearch = ({
	search,
	limit,
	initialData,
}: {
	search?: string;
	limit?: number;
	initialData?: BlokData["corrections"];
}) => {
	return useQuery({
		queryKey: ["corrections", { search, limit }],
		queryFn: async () => {
			const corrections = await rpc.story.bloks.searchCorrections({
				query: search,
				limit,
			});

			return corrections;
		},
		refetchOnMount: true,
		initialData: initialData,
	});
};
